var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slidecontainer"},[_c('input',{staticClass:"slider",attrs:{"type":"range","min":_vm.min,"max":_vm.max},domProps:{"value":_vm.value},on:{"input":function (e) { return _vm.$emit('input', e.target.value); }}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c7b3c00","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/misc/slider.vue
// module id = WLzm
// module chunks = 0 108 116